import {connect} from "react-redux";
                                                                                // import {initialize,reset} from 'redux-form';
                                                                                // import {reset, getFormValues, getFormInitialValues} from 'redux-form';
import {reset, getFormValues} from 'redux-form';
import {
  GET_PROGRAMS_LIST,
  GET_REFERRALOUTCOME_LIST,
  GET_BOPINSTITUTIONS_LIST,
  GET_DRUGAFTERCAREPROGRAMS_LIST,
  GET_GANGAFFILIATIONS_LIST,
  GET_REFERRALSOURCE_LIST,
                                                    // GET_BHTsINSURANCEPROVIDERS_LIST,
} from '../actions/action-constants';
import {
  getDropDownsList
} from '../actions/actions-drop-downs';
import {
  getClient,
  updateClientSave,
  updateClientSaveAndClose,
  transferClient,
  changeProgram,
} from '../actions/actions-clients';
import {
  archiveClient
} from '../actions/actions-archived-clients';
import ClientEditRoot from '../components/edit-view-client/client-container-root-edit';
const mapStateToProps = (state, ownProps) => {
  return {
    parentProps: ownProps,
    initialValues: state.clientsR.dataEntry,
                                                                                      currentFormState: getFormValues('ClientEditForm')(state), // testing not needed
    programsList: state.programsR,
    referralOutcomesList: state.referraloutcomesR,
                                                    // bhtsinsuranceprovidersList: state.bhtsinsuranceprovidersR,
    // bopinstitutionsList: state.bopinstitutionsR,
    // gangaffiliationsList: state.gangaffiliationsR,
    // referralsourcesList: state.referralsourcesR,
    bopinstitutionsList: state.bopinstitutionsR.bopinstitutions,
    gangaffiliationsList: state.gangaffiliationsR.gangaffiliations,
    referralsourcesList: state.referralsourcesR.referralsources,
    loadingList: state.clientsR.loadingList,
    errorInvalidEntry: state.clientsR.errorInvalidEntry,
  };
};
const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    getClient: (id) => {
      dispatch(getClient(id) );},

    getPrograms: (params) => {
      dispatch(getDropDownsList( params, GET_PROGRAMS_LIST) );},  
    getReferralOutcomes: (params) => {
      dispatch(getDropDownsList( params, GET_REFERRALOUTCOME_LIST) );},
                                                            // getBHTsInsuranceProviders: (params) => {
                                                            //   dispatch(getDropDownsList( params, GET_BHTsINSURANCEPROVIDERS_LIST) );},
    getBOPInstitutions: (params) => {
      dispatch(getDropDownsList( params, GET_BOPINSTITUTIONS_LIST) );},
    getDrugAftercarePrograms: (params) => {
      dispatch(getDropDownsList( params, GET_DRUGAFTERCAREPROGRAMS_LIST) );},
    getGangAffiliations: (params) => {
      dispatch(getDropDownsList( params, GET_GANGAFFILIATIONS_LIST) );},
    getReferralSources: (params) => {
      dispatch(getDropDownsList( params, GET_REFERRALSOURCE_LIST) );},


    updateClientSave: (id, clientEntry) => {
      dispatch(updateClientSave(id, clientEntry) )
      ; },
    updateClientSaveAndClose: (id, clientEntry) => {
      dispatch(updateClientSaveAndClose(id, clientEntry) )
        .then(() => dispatch(reset('ClientEditForm')) )
        .then(() => ownProps.history.push('/clients') )  
      ; },
    changeProgram: (id, clientEntry) => {
        dispatch(changeProgram(id, clientEntry) )
          .then(() => dispatch(reset('ClientEditForm')) )
          .then(() => ownProps.history.push('/clients') )  
        ;},
    transferClient: (id, clientEntry) => {
      dispatch(transferClient(id, clientEntry) )
        .then(() => dispatch(reset('ClientEditForm')) )
        .then(() => ownProps.history.push('/clients') )
      ;},
    archiveClient: (id, clientEntry) => {
      dispatch(archiveClient(id, clientEntry) )
        .then(() => dispatch(reset('ClientEditForm')) )
        .then(() => ownProps.history.push('/clients') )  
      ;},

                                                                                            // resetForm: () => {
                                                                                            //   dispatch( reset('ClientEditForm') )
                                                                                            // ; },
                                                                                            // initializeForm: () => {
                                                                                            //   dispatch( initialize('ClientEditForm', {}) ) 
                                                                                            // ; },

  };
};
const ClientEditContainer = connect(mapStateToProps, mapDispatchToProps)(ClientEditRoot);
export default ClientEditContainer;